import React from 'react';
import { ProductSuggestions } from '@vpp-frontend-components/product-suggestions';
import classnames from 'classnames';
import { shape, string, oneOf, number, func, arrayOf } from 'prop-types';

const ProductSuggestionsMobile = ({ style, ...props }) => {
  const marginClass = classnames({ 'mt-16 mr-16 ml-16': style });

  return <ProductSuggestions className={marginClass} style={style} {...props} />;
};

ProductSuggestionsMobile.propTypes = {
  className: string,
  content: shape({
    title: shape({
      text: string,
      color: string,
      font_size: string,
      font_family: string,
    }),
    description: shape({
      text: string,
      color: string,
      font_size: string,
      font_family: string,
    }),
  }),
  action: shape({
    label: shape({
      text: string,
      color: string,
      font_size: string,
      font_family: string,
    }),
    target: string,
    accessibility_text: string,
    icon: shape({
      id: string,
      color: string,
    }),
  }),
  thumbnails: shape({
    pictures: arrayOf(
      shape({
        alt: string,
        url: shape({
          src: string,
        }),
      }),
    ),
    container_type: string,
    container_size: number,
    container_style: string,
    more_quantity: number,
  }),
  style: shape({
    background_color: string,
    background_color_hex: string,
    background_gradient_color: string,
    background_gradient_color_hex: string,
    shadow: oneOf(['OUTLINE', 'ELEVATED', 'FLAT', 'NONE']),
    shadow_color: string,
    shadow_color_hex: string,
    thumbnail_shadow_color: string,
  }),
  shadow: string,
  background_color: string,
  runCatchErrorBoundary: func,
};

export default ProductSuggestionsMobile;
